import React from "react";
import "../styles/Footer.css";

function Footer() {
  return (
    <div className="footer">
      <p>2025 jessewashburn.com</p>
    </div>
  );
}

export default Footer;
